/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */

import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { CommonConstants } from '../common/constants/common-constants';
import { retry, retryWhen, take, tap } from 'rxjs/operators';


@Injectable()
export class RequestInterceptor implements HttpInterceptor {

    constructor(private injector: Injector) {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        // Intercept all REST calls
        if (request.url.startsWith('/v1/')) {
            const baseUrl = this.getBaseURL();
            request = request.clone({
                url : baseUrl + request.url,
                setParams: {
                    locale: this.injector.get(TranslateService).getBrowserCultureLang()
                }
            });
        }

        if (request.url.includes('/auth/oauthLogin')) {
            return next.handle(request).pipe(retryWhen(error =>
                error.pipe(tap((response) => {
                    if (response.status === 400) {
                        throw response;
                    }
                }),
                    take(CommonConstants.RETRY_COUNT)
                )
            ))
        } else {
            return next.handle(request).pipe(retry(CommonConstants.RETRY_COUNT));
        }
    }

    getBaseURL(): string {
        // Alternative for location.origin as that was problmatic in few versions of IE
        return location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '')
        + CommonConstants.SERVICE_BASE_PATH;
    }
}
